<template>
    <Card :header="$t('filters')">

        <form @keyup.enter="parentComponent.filterData()">

            <b-form-group :label="$t('id')" label-cols-sm="3">
                <b-form-input v-model="parentComponent.filters.id" :disabled="loading" />
            </b-form-group>

            <b-form-group :label="$t('catalogId')" label-cols-sm="3">
                <b-form-input v-model="parentComponent.filters.catalogId" :disabled="loading" />
            </b-form-group>

            <b-form-group :label="$t('riskScoreFrom')" label-cols-sm="3">
                <b-form-spinbutton v-model="parentComponent.filters.riskScoreFrom" :disabled="loading" min="0" :max="parentComponent.filters.riskScoreTo" step="0.01" />
            </b-form-group>

            <b-form-group :label="$t('riskScoreTo')" label-cols-sm="3">
                <b-form-spinbutton v-model="parentComponent.filters.riskScoreTo" :disabled="loading" :min="parentComponent.filters.riskScoreFrom" max="10" step="0.01" />
            </b-form-group>

            <div class="d-flex gap-3">
                <ButtonIcon :disabled="parentComponent.loading" @click="parentComponent.filterData()">
                    {{ $t('filter') }}
                </ButtonIcon>
                <ButtonIcon variant="light" :disabled="parentComponent.loading" @click="parentComponent.resetData()">
                    {{ $t('reset') }}
                </ButtonIcon>
            </div>

        </form>
    </Card>
</template>



<script>
    export default {
        name: 'Filters',
        inject: {
            parentComponent: {
                default: null,
            },
        },
        computed: {
            loading() {
                return this.parentComponent.loading;
            },
        },
    };
</script>
